<template>
  <UPageSection
    v-if="items.length"
    :dir="dir"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl text-center',
      container: 'py-10 sm:py-14',
    }"
  >
    <div
      class="grid gap-3"
      :class="gridClass"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex h-full flex-col items-center justify-center gap-2 rounded-xl border border-default/50 bg-default/60 p-4 text-center shadow-sm"
      >
        <div class="flex h-12 w-full items-center justify-center">
          <img
            v-if="item.logo"
            :src="item.logo"
            :alt="item.name || 'Insurance'"
            class="max-h-12 w-auto max-w-full object-contain"
          >
          <div
            v-else
            class="flex size-11 items-center justify-center rounded-full bg-primary/10 text-primary"
          >
            <UIcon
              name="i-lucide-shield-check"
              class="size-5"
            />
          </div>
        </div>
        <span
          v-if="item.name"
          class="text-sm font-medium text-highlighted"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </UPageSection>
</template>

<script setup lang="ts">
export type InsuranceItem = {
  name?: string
  logo?: string
}

const props = withDefaults(
  defineProps<{
    title?: string
    items?: InsuranceItem[]
  }>(),
  {
    items: () => [],
  },
)

const dir = useDir()

const gridClass = computed(() => {
  const n = props.items.length
  if (n <= 2) return 'sm:grid-cols-2'
  if (n <= 3) return 'sm:grid-cols-3'
  if (n <= 4) return 'sm:grid-cols-2 lg:grid-cols-4'
  return 'sm:grid-cols-2 lg:grid-cols-5'
})
</script>
